// components/PhoneInput.jsx
import React from "react";
import ReactPhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

export default function PhoneInput(props) {
  return <ReactPhoneInput {...props} />;
}
